import React from 'react';
import { useLocation, useNavigate } from '../nav';
import { VeeMascot } from '../components/VeeMascot';
import { CustomIcon } from '../components/CustomIcons';
import { billQuery, paymentQuery, readPayment } from '../lib/transfer';
export function Draft() {
  const navigate = useNavigate();
  const {
    pathname,
    search
  } = useLocation();
  const payment = readPayment(pathname + search);
  const query = payment.isBill ? billQuery(payment) : paymentQuery(payment);
  return <main className="flex h-full w-full flex-col bg-brand-cloud" data-id="element-414" data-mp="2b05u22p6s34v">
      <header className="flex items-center gap-3 bg-white px-5 pb-4 pt-14" data-id="element-415" data-mp="2ayl28ku9ayap">
        <button onClick={() => navigate(-1)} aria-label="Go back" className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-cloud text-brand-navy" data-id="element-416" data-mp="2g0ada0hhbbys">←</button>
        <div data-id="element-417" data-mp="llr9lul7b2f6">
          <p className="text-[10px] font-extrabold uppercase tracking-[.16em] text-brand-cobalt" data-id="element-418" data-mp="llzplvcmenul">Prepared payment</p>
          <h1 className="mt-1 text-lg font-extrabold tracking-tight text-brand-navy" data-id="element-419" data-mp="ql3wugfzibia">{payment.title}</h1>
        </div>
      </header>

      <section className="phone-scroll flex-1 overflow-y-auto px-5 py-5" data-id="element-420" data-mp="15a5rms2cw8eh">
        <div className="flex items-center gap-3 rounded-[22px] bg-[#10294a] p-4 text-white" data-id="element-421" data-mp="10frwmqrlw3ac">
          <VeeMascot size={44} state="speaking" decorative data-id="element-422" data-mp="vj1dfuki8rkp" />
          <p className="text-xs leading-relaxed text-blue-100" data-id="element-423" data-mp="qjouvm0o26nx"><strong className="text-white" data-id="element-424" data-mp="qkzwbf6n32bv">This draft is prepared, not sent.</strong> Review the complete details below.</p>
        </div>

        <article className="relative mt-5 overflow-hidden rounded-[30px] bg-white p-5 shadow-float" data-id="element-425" data-mp="1j83up1b88ieo">
          <div className="flex items-center gap-4 border-b border-slate-100 pb-5" data-id="element-426" data-mp="1e8hjexeylc8i">
            <span className="flex h-14 w-14 items-center justify-center rounded-[18px] bg-brand-cloud text-brand-cobalt" data-id="element-427" data-mp="1ealt5vzjh5gp"><CustomIcon name={payment.icon} size={26} data-id="element-428" data-mp="2tm213oxgwo9" /></span>
            <div className="min-w-0" data-id="element-429" data-mp="2ux7r91xoei0">
              <p className="text-[11px] font-bold uppercase tracking-[.14em] text-brand-slate" data-id="element-430" data-mp="3uxmzy3jcrodh">{payment.isBill ? 'Service' : 'Recipient'}</p>
              <h2 className="mt-1 truncate text-xl font-extrabold tracking-tight text-brand-navy" data-id="element-431" data-mp="ahc99cmm8tn">{payment.party}</h2>
              <p className="mt-1 text-xs font-semibold text-brand-slate" data-id="element-432" data-mp="57hjvop4jjmv">{payment.bank} · {payment.account}</p>
            </div>
          </div>
          <div className="mt-5 grid grid-cols-2 gap-3" data-id="element-433" data-mp="3rf7eh3oah4hb">
            <Metric label="Source" value="VE Bank Account" data-id="element-434" data-mp="3rdmkbf5vznjz" />
            <Metric label="Amount" value={`₦${payment.amount}`} strong data-id="element-435" data-mp="3dnsr6kncmh4g" />
            <Metric label="Fee" value="₦0.00" data-id="element-436" data-mp="3ieiyw4j8yw2b" />
            <Metric label="Total debit" value={`₦${payment.amount}`} strong data-id="element-437" data-mp="3igc73o9idocf" />
          </div>
          <div className="mt-5 border-t border-slate-100 pt-4" data-id="element-438" data-mp="33r7mk0f8r815">
            <p className="text-[10px] font-extrabold uppercase tracking-[.14em] text-brand-slate" data-id="element-439" data-mp="38og88azllu75">Narration</p>
            <p className="mt-1 text-sm font-bold text-brand-navy" data-id="element-440" data-mp="2uoydlezmfmpv">{payment.narration}</p>
          </div>
        </article>

        <button onClick={() => navigate(payment.isBill ? `/bill?service=${encodeURIComponent(payment.bill || '')}&prov=${encodeURIComponent(payment.party)}&target=${encodeURIComponent(payment.account)}` : '/transfer')} className="mt-4 min-h-[48px] w-full rounded-2xl bg-white text-sm font-extrabold text-brand-cobalt shadow-soft" data-id="element-441" data-mp="2ypicoo3r90en">
          {payment.isBill ? 'Edit biller or amount' : 'Edit recipient or amount'}
        </button>

        <aside className="mt-4 flex gap-3 rounded-[22px] border border-orange-100 bg-orange-50 p-4" data-id="element-442" data-mp="2u2ahaz93wt24">
          <span className="mt-0.5 font-extrabold text-brand-orange" aria-hidden="true" data-id="element-443" data-mp="37tny45fmrctg">!</span>
          <p className="text-xs leading-relaxed text-brand-slate" data-id="element-444" data-mp="37vict20b68p3">If you continue, the account above will be reviewed for a <strong className="text-brand-navy" data-id="element-445" data-mp="3hrllyrtkv7lj">₦{payment.amount}</strong> debit. You can still go back.</p>
        </aside>
      </section>

      <footer className="border-t border-slate-200 bg-white p-5" data-id="element-446" data-mp="3cu3aato6ee9u">
        <button onClick={() => navigate(`/review?${query}`)} className="flex min-h-[54px] w-full items-center justify-between rounded-2xl bg-brand-cobalt px-5 text-sm font-extrabold text-white" data-id="element-447" data-mp="pqwvdyxf3sq">
          Continue to review <span aria-hidden="true" data-id="element-448" data-mp="9hj1h819ripe">→</span>
        </button>
      </footer>
    </main>;
}
function Metric({
  label,
  value,
  strong = false
}: {
  label: string;
  value: string;
  strong?: boolean;
}) {
  return <div className="rounded-2xl bg-brand-cloud p-3" data-id="element-449" data-mp="3dx2cscfmu7sn">
      <p className="text-[9px] font-extrabold uppercase tracking-[.12em] text-brand-slate" data-id="element-450" data-mp="3dydgkc92vfjr">{label}</p>
      <p className={`mt-1 text-xs tabular-nums ${strong ? 'font-extrabold text-brand-navy' : 'font-bold text-brand-slate'}`} data-id="element-451" data-mp="3hzfempr9dlk5">{value}</p>
    </div>;
}